export default (val) => {
  const styles = new Option().style
  styles.color = val

  return val && (styles.color === val || (val[0] === "#" && !val[7])) // Checks also for HEX colors in format #XXXXXX 
}
